/* ===================================================================
   msw-track.js — capa de medición de embudo (GA4)

   Qué hace: emite eventos para saber DÓNDE se cae la gente — qué
   secciones de la home ve cada uno, hasta dónde baja, qué CTA le trae
   al configurador, y (fase 2) en qué paso del configurador abandona.

   Reglas de esta capa:
   · No toca el aspecto ni el comportamiento de la web. Solo observa.
   · Si falta el ID de GA4, no se ejecuta NADA (interruptor de apagado
     desde el editor de temas: Ajustes → Analytics → dejar en blanco).
   · Nunca sale información personal. Ni el nombre del niño, ni el
     email, ni la dedicatoria, ni la foto. Los campos de texto solo
     reportan "filled" / "valid".
   · Todo va envuelto en try/catch: un fallo aquí jamás puede romper
     la tienda.

   El consentimiento se gestiona con Consent Mode v2. La denegación
   por defecto se declara en theme.liquid ANTES de cargar gtag; aquí
   solo se actualiza cuando el visitante responde al banner de Shopify.

   API pública (la usan msw.js y msw-create.js):
     mswTrack(nombre, params)              → evento
     mswTrack.once(clave, nombre, params)  → evento una sola vez por carga
     mswTrack.sid()                        → id de sesión de embudo
     mswTrack.set(params)                  → params que viajan en todos
   =================================================================== */
(function () {
  'use strict';

  /* ---- Guardas duras: si algo de esto falla, ni nos molestamos ---- */
  var GA4 = (window.MSW_GA4_ID || '').trim();
  if (!GA4) return;                                   // interruptor apagado
  if (window.Shopify && window.Shopify.designMode) return;  // editor de temas: no contaminar
  if (typeof window.gtag !== 'function') return;

  var DEBUG = /[?&]msw_debug=1/.test(location.search);
  if (DEBUG) { try { gtag('set', {debug_mode: true}); } catch (e) {} }

  var T0 = Date.now();

  /* ================= Identificador de sesión de embudo =================
     Se reutiliza el `id` del borrador que el configurador ya guarda en
     localStorage.msw_draft (msw-create.js:101). Así la visita a la home
     y la del configurador son el MISMO usuario, y como ese id viaja al
     pedido como "_Character ref", los eventos se pueden cruzar con
     pedidos reales de Shopify. */
  var SID_KEY = 'msw_sid', _sid = null;
  function sid() {
    if (_sid) return _sid;
    try {
      var d = JSON.parse(localStorage.getItem('msw_draft') || 'null');
      if (d && d.id) { _sid = d.id; return _sid; }
    } catch (e) {}
    try {
      _sid = localStorage.getItem(SID_KEY) || '';
    } catch (e) {}
    if (!_sid) {
      _sid = 'msw_' + Math.random().toString(16).slice(2, 10);
      try { localStorage.setItem(SID_KEY, _sid); } catch (e) {}
    }
    return _sid;
  }

  /* ================= Envío ================= */
  var common = {
    msw_sid:  sid(),
    msw_vp:   window.matchMedia('(max-width:600px)').matches ? 'compact' : 'wide',
    msw_page: window.MSW_PAGE || 'other'
  };
  try { gtag('set', common); } catch (e) {}

  function send(name, params, beacon) {
    try {
      var p = params || {};
      if (beacon) p.transport_type = 'beacon';
      gtag('event', name, p);
      if (DEBUG) console.log('[msw-track]', name, p);
    } catch (e) {}
  }

  /* Anti-duplicado: eventos que solo tienen sentido una vez por carga */
  var fired = {};
  function once(key, name, params) {
    if (fired[key]) return;
    fired[key] = 1;
    send(name, params);
  }

  /* ================= API pública ================= */
  var queued = window.mswTrack && window.mswTrack.q;
  var queuedOnce = window.mswTrack && window.mswTrack.oq;

  function mswTrack(name, params) { send(name, params); }
  mswTrack.once = once;
  mswTrack.sid  = sid;
  mswTrack.set  = function (params) {
    try { gtag('set', params || {}); } catch (e) {}
  };
  window.mswTrack = mswTrack;

  /* Drenar lo que se disparó antes de que este fichero cargara */
  try {
    if (queued)     for (var i = 0; i < queued.length; i++)     send(queued[i][0], queued[i][1]);
    if (queuedOnce) for (var j = 0; j < queuedOnce.length; j++) once(queuedOnce[j][0], queuedOnce[j][1], queuedOnce[j][2]);
  } catch (e) {}

  /* ================= Consentimiento (RGPD — banner de Shopify) =======
     La API de privacidad de Shopify NO viene cargada por defecto: hay
     que pedirla con loadFeatures. Cuando responde, y cada vez que el
     visitante cambia su elección, se actualiza el Consent Mode. */
  function applyConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return;
      var analytics  = cp.analyticsProcessingAllowed ? cp.analyticsProcessingAllowed() : false;
      var marketing  = cp.marketingAllowed ? cp.marketingAllowed() : false;
      gtag('consent', 'update', {
        analytics_storage:  analytics ? 'granted' : 'denied',
        ad_storage:         marketing ? 'granted' : 'denied',
        ad_user_data:       marketing ? 'granted' : 'denied',
        ad_personalization: marketing ? 'granted' : 'denied'
      });
      if (DEBUG) console.log('[msw-track] consent', {analytics: analytics, marketing: marketing});
    } catch (e) {}
  }
  try {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (err) {
        if (!err) applyConsent();
      });
    }
  } catch (e) {}
  document.addEventListener('visitorConsentCollected', applyConsent);

  /* ================= Utilidades ================= */
  function scrollPct() {
    try {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return 100;
      return Math.min(100, Math.max(0, Math.round(window.scrollY / h * 100)));
    } catch (e) { return 0; }
  }
  function secName(el) {
    return (el.dataset && el.dataset.mswSec) || el.id || '';
  }

  /* ================= Vista de secciones =============================
     Observer PROPIO. No se reutiliza el de msw.js:5-14 porque ése
     observa [data-reveal] (elementos sueltos, no secciones) con
     threshold 0.12 y unobserve inmediato: daría vistas falsas y
     rompería la animación de entrada.
     El índice se deriva del orden real del DOM, nunca se escribe a
     mano — así sobrevive a cualquier reordenación futura. */
  function watchSections() {
    var secs = [].slice.call(document.querySelectorAll('section[id], section[data-msw-sec]'))
                 .filter(function (s) { return secName(s) && s.id !== 'shopify-pc__banner'; });
    if (!secs.length) return;

    var index = {};
    secs.forEach(function (s, n) { index[secName(s)] = n + 1; });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = secName(en.target);
        io.unobserve(en.target);
        once('sec:' + name, 'msw_section_view', {
          section: name,
          section_index: index[name],
          scroll_pct: scrollPct(),
          ms_since_load: Date.now() - T0
        });
      });
    }, {threshold: 0.5});
    secs.forEach(function (s) { io.observe(s); });
  }

  /* ================= Profundidad de scroll ==========================
     `maxPct` es de ámbito de módulo a propósito: el evento de abandono
     tiene que reportar hasta dónde llegó DE VERDAD el usuario, no dónde
     estaba al cerrar. Quien baja hasta el final y luego vuelve arriba
     llegó al 100 %, no al 5 %. */
  var maxPct = 0;
  function watchScroll() {
    var marks = [25, 50, 75, 90, 100];
    function measure() {
      try {
        var p = scrollPct();
        if (p <= maxPct) return;
        maxPct = p;
        marks.forEach(function (m) {
          if (maxPct >= m) once('depth:' + m, 'msw_scroll_depth', {depth_pct: m});
        });
      } catch (e) {}
    }
    measure();   // páginas cortas: ya se ven enteras sin hacer scroll
    window.addEventListener('scroll', measure, {passive: true});
  }

  /* ================= Clics en CTA ===================================
     Un único listener delegado. Cubre de golpe los CTAs de la home y
     los de destino/blog/artículo/404/cesta en cuanto lleven el
     atributo, sin añadir un listener por enlace.
     La atribución entre páginas va por sessionStorage: NADA de añadir
     ?utm_content= a enlaces internos (fragmentaría la caché, crearía
     URLs duplicadas en Search Console y ensuciaría el informe de
     páginas de destino). Los data-* son invisibles para Google. */
  function watchCtas() {
    document.addEventListener('click', function (ev) {
      try {
        var el = ev.target && ev.target.closest && ev.target.closest('[data-msw-cta]');
        if (!el) return;
        var id = el.getAttribute('data-msw-cta') || '';
        var host = el.closest('section[id], section[data-msw-sec]');
        try { sessionStorage.setItem('msw_cta', id); } catch (e) {}
        send('msw_cta_click', {
          cta_id: id,
          cta_label: (el.textContent || '').trim().slice(0, 40),
          cta_page: common.msw_page,
          section: host ? secName(host) : '',
          scroll_pct: scrollPct()
        });
      } catch (e) {}
    }, true);
  }

  /* ================= Abandono =======================================
     pagehide con beacon: es lo único que llega de forma fiable cuando
     el usuario cierra la pestaña o se va (unload ya no es fiable en
     móvil). Da la foto final de hasta dónde llegó. */
  function watchExit() {
    window.addEventListener('pagehide', function () {
      try {
        send('msw_abandon', {
          max_scroll_pct: Math.max(maxPct, scrollPct()),
          exit_scroll_pct: scrollPct(),
          dwell_ms: Date.now() - T0,
          exit_page: common.msw_page
        }, true);
      } catch (e) {}
    });
  }

  /* ================= Arranque ================= */
  function boot() {
    try { watchSections(); } catch (e) {}
    try { watchScroll(); }   catch (e) {}
    try { watchCtas(); }     catch (e) {}
    try { watchExit(); }     catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
